<template>
  <BModal
    id="modal-change-label"
    ref="modal-change-label"
    no-stacking
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <ValidationObserver #default="{ invalid }">
      <BRow class="justify-center my-1 flex flex-column gap-4">
        <BCol class="flex justify-center">
          <img
            src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
            alt="Komerce"
            width="100"
          >
        </BCol>
        <BCol class="d-flex justify-content-center text-black font-semibold text-xl">
          Ubah Label Kartu
        </BCol>
        <BCol class="d-flex justify-content-center text-black font-normal text-lg text-center">
          Kamu bisa mengubah label kartu sesuai dengan merchant yang akan kamu tautkan ke kartu ini
        </BCol>
        <BCol class="justify-content-center">
          <BFormGroup>
            <template #label>
              <div class="text-black">
                Nama label kartu saat ini
              </div>
            </template>
            <BFormInput
              v-model="card.labels"
              :placeholder="card.labels ? card.labels : '-'"
              disabled
            />
          </BFormGroup>
        </BCol>
        <BCol class="justify-content-center">
          <BFormGroup>
            <template #label>
              <div class="text-black">
                <strong class="text-primary">*</strong>
                <span>Nama label baru</span>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Nama label baru"
              :rules="{required: true, max:50}"
            >
              <BFormInput
                v-model="label"
                placeholder="ex. Facebook, Tokopedia, Shopee"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol cols="6">
          <BButton
            variant="outline-primary"
            block
            @click="
              $refs['modal-change-label'].hide()
              label = null
            "
          >
            Batal
          </BButton>
        </BCol>
        <BCol cols="6">
          <BButton
            :disabled="invalid"
            :variant="invalid ? 'secondary' : 'primary'"
            type="submit"
            block
            @click.prevent="onUpdate"
          >
            Ubah Label
          </BButton>
        </BCol>
      </BRow>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, min, max,
} from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      min,
      max,
      label: null,
    }
  },
  methods: {
    onUpdate() {
      this.$bvModal.show('modal-verify-pin')
      this.$bvModal.hide('modal-change-label')
      this.updateInput()
    },
    updateInput() {
      this.$emit('update-input', this.label)
    },
    onReset() {
      this.label = null
    },
  },
}
</script>
